import {ChangeDetectionStrategy, Component, inject, signal,} from '@angular/core';
import {NavigationService} from '../../services/nav/navigation.service';
import {UserService} from '../../services/user/user.service';
import {UserDto} from '@api/utisha-backend';
import {ChatUpdateService} from '../../services/chat-update-service';
import {TranslatePipe} from '@ngx-translate/core';
import {UtIconComponent} from '../../ui/icon/ut-icon.component';

@Component({
  selector: 'app-general-chat-indicator',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './general-chat-indicator.component.html',
  styleUrls: ['./general-chat-indicator.component.scss'],
  imports: [TranslatePipe, UtIconComponent],
})
export class GeneralChatIndicatorComponent {
  private readonly userService = inject(UserService);
  private readonly chatUpdateService = inject(ChatUpdateService);
  public readonly nav = inject(NavigationService);

  protected readonly newMessages = signal<number>(0);
  private user: UserDto | undefined;

  constructor() {
    this.userService.getUser().then((u) => (this.user = u));
    this.chatUpdateService
      .getNewMessages()
      .subscribe((count: number) => this.newMessages.set(count));
  }

  protected badgeLabel(): string {
    const count = this.newMessages();
    if (count <= 0) return '';
    return count > 99 ? '99+' : String(count);
  }

  protected async gotoChat(): Promise<void> {
    if (!this.user?.userType) return;
    this.chatUpdateService.reset();
    this.nav.generalChat(this.user.userType);
  }
}
